/*
 * value         : waarde als input String (kan Observable zijn)
 * onSelect?     : callback wat er gebeurd als er geselecteerd wordt (kan Object zijn als source Array<Object> is)
 * source        : Kan Array, Observable<Array> of functie zijn: fetch(inputText, Callback functie) =>{}
 * label         : de eigenschap die getoond moet worden als source een array is met Objects (string)
 * sizeToElement : de uitklaplijst moet de breedte van dit elemen aannemen (cssSelector als string, of HTMLElement)
 * 
 * TODO: vergelijkbaar laten werken met options-binding (met optionsText en optionsValue)
 * */
ko.bindingHandlers.autocomplete = {
    addButton: function (container, title, icon, func) {
        const optionalButton = DOM.create(
            'BUTTON',
            'btn btn-default ' + icon,
            { margin: '2px', float: 'right' })

        optionalButton.title = title

        const optionalButtonClickHandler = () => {
            container.remove();
            func()
        }
        optionalButton.addEventListener('click', optionalButtonClickHandler)

        container.prepend(optionalButton);

        return () => {
            optionalButton.removeEventListener('click', optionalButtonClickHandler)
        }
    },
    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
        const lens = (value, prop) => (prop) ? value[prop] : value;

        //https://github.com/kraaden/autocomplete
        const userOptions = ko.utils.unwrapObservable(valueAccessor());
        const observable = userOptions.value;

        const totalOptions = {};
        let optionalButton
        let optionalButtonClickHandler
        Object.assign(totalOptions, ko.bindingHandlers.autocomplete.defaultOptions)
        Object.assign(totalOptions, userOptions);

        const onInput = (e) => {
            observable(element.value);
            return true;
        }

        element.addEventListener(totalOptions.updateEvent, onInput);

        if (!('onSelect' in totalOptions)) {
            totalOptions.onSelect = (item) => {
                const _label = lens(item, totalOptions.label);
                const _value = lens(item, totalOptions.idProp)

                observable(_value);
                element.value = _label;
            }
        }

        if (ko.isSubscribable(totalOptions.value)) {
            totalOptions.value.subscribe(function (value) {
                element.value = value
            })
        }
        let doFetch;
        if ((totalOptions.source instanceof Array) ||
            ko.isObservable(totalOptions.source)) {
            doFetch = (text, update) => {
                const v = text.trim().toLowerCase();

                const source = ko.unwrap(totalOptions.source)
                update(
                    source.filter(i => {
                        const key = ('label' in totalOptions) ? i[totalOptions.label] : i;
                        return key.toLowerCase().indexOf(v) > -1;
                    }))
            }
        } else {
            doFetch = totalOptions.source;
        }

        element.value = observable();

        const defaultRenderFunction = ko.bindingHandlers.autocomplete.
            renderFunction(totalOptions.label);

        totalOptions.input = element;
        totalOptions.fetch = doFetch;
        totalOptions.render = (totalOptions.render ?? defaultRenderFunction);
        totalOptions.customize = (input, rect, container, maxHeight) => {

            //Neem de positie+breedte over van het opgegeven element
            if (userOptions.sizeToElement) {

                //document.querySelector(userOptions.sizeToElement)
                const el = (typeof userOptions.sizeToElement === 'string') ?
                    element.closest(userOptions.sizeToElement) :
                    userOptions.sizeToElement;

                const x = el.getBoundingClientRect().x;
                const width = el?.offsetWidth;

                if (userOptions.buttonClick && userOptions.buttonTitle) {

                    ko.bindingHandlers.autocomplete.addButton(
                        container,
                        userOptions.buttonTitle,
                        userOptions.buttonCss,
                        userOptions.buttonClick)
                }

                if (userOptions.buttonClick2 && userOptions.buttonTitle2) {

                    ko.bindingHandlers.autocomplete.addButton(
                        container,
                        userOptions.buttonTitle2,
                        userOptions.buttonCss2,
                        userOptions.buttonClick2)
                }

                if (width) {
                    container.style.width = width + 'px';
                    container.style.left = x + 'px';
                }
            }

            //resize
            const screenHeight = window.innerHeight;
            const inputHeight = input.getBoundingClientRect().top;

            const isLowerPortion = inputHeight > (screenHeight * 0.7);

            //flip
            if (totalOptions.addLayoutStyle) {
                container.classList.toggle('expand-up', isLowerPortion)
                container.classList.toggle('expand-down', !isLowerPortion)
            }

            if (isLowerPortion) {
                container.style.top = "";
                container.style.bottom = (window.innerHeight - rect.bottom + input.offsetHeight) + "px";
                container.style.maxHeight = "200px";
            } else {
            }

        }

        const instance = autocomplete(totalOptions);

        element._autoComplete = instance;

        ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
            optionalButton?.removeEventListener('click', optionalButtonClickHandler);
            element.removeEventListener('input', onInput);
            instance.destroy();
        });

    },
    renderFunction: function (label) {
        return (item, currentValue) => {
            const div = document.createElement("div");
            const textContent = (label) ?
                item[label] :
                item;

            div.classList.add('text-overflow');
            div.textContent = textContent;
            div.title = textContent;
            return div;
        }
    },
    defaultOptions: {
        updateEvent: 'input',
        preventSubmit: false,
        minLength: 1,
        disableAutoSelect:false,
        debounceWaitMs: 0,
        addLayoutStyle: true /*adds style specific for use in layouts*/
    },
}
